<ng-container *ngIf="plan.isPopular">
    <div class="popular-wrapper {{plan.id == selectedPricing ? 'selected' : ''}}">
        <div *ngIf="plan.isPopular" class="popular-badge">MOST POPULAR</div>
        <ng-container *ngTemplateOutlet="cardContents"></ng-container>
    </div>
</ng-container>
<ng-container *ngIf="!plan.isPopular">
    <ng-container *ngTemplateOutlet="cardContents"></ng-container>
</ng-container>

<ng-template #cardContents>
    <div 
        class="pricing-card"
        [class.popular]="plan.isPopular"
        [class.selected]="selectedPricing == plan.id"
        (click)="selectPlan()"
    >
        <div class="pricing-radio">
            <input 
                type="radio" 
                [id]="plan.id"
                [value]="plan.id"
                [checked]="selectedPricing == plan.id"
                name="pricingOption"
                (change)="selectPlan()"
            />
            <label [for]="plan.id" [class.checked]="selectedPricing == plan.id"></label>
        </div>
        <div class="pricing-content">
            <div class="pricing-label">{{ plan.label }}</div>
            <div class="pricing-price">
                <span class="original-price">${{ plan.originalPrice }}</span>
                <span class="current-price">
                    <span class="price-amount">${{ plan.currentPrice }}</span>
                    <span class="price-period"> / MO</span>
                </span>
            </div>
        </div>
    </div>
</ng-template>

